import { render, staticRenderFns } from "./iconWithTooltip.vue?vue&type=template&id=45fbaf0c"
import script from "./iconWithTooltip.vue?vue&type=script&lang=js"
export * from "./iconWithTooltip.vue?vue&type=script&lang=js"
import style0 from "./iconWithTooltip.vue?vue&type=style&index=0&id=45fbaf0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports